import React, { useEffect, useState } from "react";
import Container from "../../components/ui/Container";
import { ReactComponent as Pointer } from "../../assets/pointer.svg";
import { ReactComponent as Location } from "../../assets/LOCATION.svg";
import locatioPin from "../../assets/locatioPin.png";
import Heading from "../../components/NewUi/heading/Heading";
import http from "../../services/httpServices";
import LoadingIcon from "../../components/ui/LoadingIcon";
import InputField from "../../components/form/elements/InputField";
import { handleInputChange } from "../../services/formServices";
import { Icon } from "@iconify/react/dist/iconify.js";
import waledImg from "../../assets/profile.png";
const StoreLocator = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [filterData, setFilterData] = useState({
        government_id: 0,
    });
    const [governments, setGovernments] = useState([]);
    const [storesByGovernment, setStoresByGovernment] = useState([]);
    const [allStores, setAllStores] = useState([]);
    const [seeMore, setSeeMore] = useState({});
    const toggleSeeMore = (government) => {
        setSeeMore((prev) => ({
            ...prev,
            [government]: !prev[government],
        }));
    };

    const getGovernments = async () => {
        try {
            const { data: response } = await http.get("/api/governments");
            setGovernments(response);
        } catch (error) {
            console.error("Error fetching governments:", error);
        }
    };
    const getStores = async () => {
        setIsLoading(true);
        try {
            const { data: response } = await http.get(`api/store_locators`);
            setAllStores(response);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };
    useEffect(() => {
        getGovernments();
        getStores();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (filterData.government_id !== 0) {
            const filteredStores = allStores.filter(
                (store) => store.government_id === filterData.government_id
            );
            const filteredStoresByGovernment = {
                [governments.find((gov) => gov.value === filterData.government_id)?.text || ""]:
                    filteredStores,
            };
            setStoresByGovernment(filteredStoresByGovernment);
        } else {
            const allStoresByGovernment = allStores.reduce((acc, store) => {
                if (!acc[store.government.name]) {
                    acc[store.government.name] = [];
                }
                acc[store.government.name].push(store);
                return acc;
            }, {});
            setStoresByGovernment(allStoresByGovernment);
        }
    }, [filterData, allStores]);

    // const handleGovernmentChange = (e) => {
    //     const selectedGovernmentId = e.currentTarget.value;
    //     const selectedValue = parseInt(e.currentTarget.value.value, 10);
    //     setFilterData({
    //         ...filterData,
    //         government_id: selectedGovernmentId,
    //         value: selectedValue,
    //     });
    // };
    return (
        <>
            <Container>
                <div className="min-h-[60vh] h-auto relative z-10 px-10 lg:px-40 py-10 ">
                    <div className="flex flex-col sm:space-y-8 sm:space-y-reverse gap-10">
                        <div className="flex flex-col lg:flex-row justify-center items-center space-y-8 md:space-y-14 lg:space-y-0">
                            <div className="flex justify-center items-center flex-col lg:justify-start lg:items-start gap-6">
                                <div className="flex gap-4 flex-col lg:flex-row items-center lg:items-start">
                                    <h3 className="font-w-bold  relative text-2xl md:text-3xl xl:text-4xl">
                                        ليه وفرنالك كل الأماكن دي ؟{" "}
                                    </h3>
                                </div>
                                <p className="text-lg text-gray-500 dark:text-gray-300 smooth text-center lg:text-right lg:text-2xl lg:w-3/4 xl:w-1/2">
                                    مش بس بنتعلم، إحنا كمان{" "}
                                    <span className="text-tomato-600 font-ibm">
                                        بنسهّل عليك الطريق!
                                    </span>{" "}
                                    كل كتب وأكواد ومحاضرات{" "}
                                    <span className="text-secYellow-500 font-semibold font-ibm">
                                        أستاذك وليد محسن
                                    </span>{" "}
                                    متاحة في منافذ توزيع علشان توصلك بسهولة.
                                </p>
                            </div>
                            {/* <Location /> */}
                            <div className="md:basis-1/2 basis-full h-full flex-center-both">
                                <div className="w-full h-full flex-center-both max-w-md">
                                    <img src={waledImg} alt={"profile"} className="w-full" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>{" "}
                <div className="flex-center-both font-ibm flex-col sm:space-y-5 gap-10">
                    <h1 className="font-w-bold relative text-4xl md:text-5xl">
                        اللي هيخليك جاهز؟ <span className="text-tomato-400">كتب وأكواد</span> منصة
                        أستاذي
                    </h1>
                    <div>
                        <div className="flex-center-both flex-col px-10 py-3  space-y-5 rounded-md bg-tomato-100 dark:bg-tomato-800/50 smooth clr-text-primary">
                            <p className="text-sectomato-200 smooth w-3/4 text-center  dark:text-tomato-200">
                                {" "}
                                اختر المنافذ القريبه من محافظتك في حالة عدم رغبتك في عرض جميع
                                المنافذ
                            </p>
                            <InputField
                                id="government_id"
                                onChange={handleInputChange}
                                placeholder="اختر محافظتك لإظهار المنافذ القريبه منك "
                                data={filterData}
                                setData={setFilterData}
                                type="select"
                                className="w-full"
                                options={[
                                    {
                                        value: 0,
                                        text: "عرض المنافذ لجميع المحافظات",
                                    },
                                    ...governments,
                                ]}
                            />
                        </div>
                    </div>
                </div>
                {isLoading ? (
                    <div className="flex-center-both">
                        <div className="border-2 rounded-md border-blue-300 dark:border-blue-500 p-10 bg-blue-100 dark:bg-opacity-5 smooth clr-text-primary flex space-x-2 space-x-reverse">
                            <LoadingIcon className="font-h1 text-blue-500" />
                            <span>يتم الآن تحميل المنافذ ...</span>
                        </div>
                    </div>
                ) : (
                    <section className="flex flex-col items-center justify-start space-y-16 px-2 sm:px-4 lg:px-8">
                        {Object.entries(storesByGovernment).map(
                            ([government, governmentStores], index) => (
                                <div
                                    key={index}
                                    className="flex justify-center space-y-10 py-10 items-center flex-col max-w-7xl"
                                >
                                    <div className="flex-center-both space-x-4 space-x-reverse">
                                        <img
                                            className="w-10 h-10"
                                            src={locatioPin}
                                            alt="locatioPin"
                                        />
                                        <h1 className="flex font-w-bold text-3xl sm:text-4xl flex-center-both space-x-4 space-x-reverse">
                                            <span className="">محافظة</span>
                                            <span className="text-secYellow-600">{government}</span>
                                        </h1>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                                        {Array.isArray(governmentStores) &&
                                        governmentStores.length > 0 ? (
                                            <>
                                                {(seeMore[government]
                                                    ? governmentStores
                                                    : governmentStores.slice(0, 3)
                                                ).map((store) => (
                                                    <div
                                                        key={store.id}
                                                        className="Card bg-tomato-50 dark:bg-tomato-900/50 smooth flex flex-col justify-center items-start gap-2 max-w-sm sm:max-w-md rounded-md card-store-shadow min-h-[170px] p-4 sm:p-6 relative"
                                                    >
                                                        <div className="absolute top-2 left-2 w-3 h-3 rounded-full bg-primary-container smooth border-[.4px] border-black dark:border-white" />
                                                        <div className="relative z-10 clr-text-primary smooth text-sm flex items-center gap-2">
                                                            <Icon
                                                                icon="mdi:store"
                                                                className="text-lg text-tomato-600"
                                                            />
                                                            اسم المنفذ: {store.name}
                                                        </div>
                                                        <div className="relative clr-text-primary z-10 smooth text-sm flex items-center gap-2">
                                                            <Icon
                                                                icon="mdi:phone"
                                                                className="text-lg text-green-600"
                                                            />
                                                            رقم التواصل: {"0" + store.phone}
                                                        </div>
                                                        <div className="relative clr-text-primary z-10 smooth text-sm flex items-center gap-2">
                                                            <Icon
                                                                icon="mdi:map-marker"
                                                                className="text-lg text-red-600"
                                                            />
                                                            العنوان: {store.address}
                                                        </div>
                                                        {store.is_books_available ||
                                                        store.is_insert_auto_available ? (
                                                            <div className="relative clr-text-primary z-10 smooth text-sm flex items-center gap-2">
                                                                <Icon
                                                                    icon="mdi:check-circle"
                                                                    className="text-lg text-tomato-600"
                                                                />
                                                                {store.is_books_available &&
                                                                store.is_insert_auto_available
                                                                    ? "متاح كتب واكواد"
                                                                    : store.is_books_available
                                                                    ? "متاح كتب فقط"
                                                                    : store.is_insert_auto_available
                                                                    ? "متاح اكواد فقط"
                                                                    : "غير متاح"}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                ))}
                                            </>
                                        ) : (
                                            <div className="font-h2 col-span-1 md:col-span-2 lg:col-span-3 py-20">
                                                <span className="flex-center-both space-x-3 space-x-reverse">
                                                    <span className="font-h1 flex-center-both text-rose-600 dark:text-rose-400">
                                                        <Icon icon="carbon:data-error" />
                                                    </span>
                                                    <span>
                                                        {" "}
                                                        لا توجد منافذ بيع متاحة في هذه المحافظة سيتم
                                                        اضافتها في اقرب وقت.
                                                    </span>
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    {Array.isArray(governmentStores) &&
                                        governmentStores.length > 3 && (
                                            <button
                                                onClick={() => toggleSeeMore(government)}
                                                className="text-blue-600 dark:text-blue-400 underline mt-4"
                                            >
                                                {seeMore[government] ? "عرض أقل" : "عرض المزيد"}
                                            </button>
                                        )}
                                </div>
                            )
                        )}
                    </section>
                )}
            </Container>
        </>
    );
};

export default StoreLocator;
